module.exports = __webpack_public_path__ + "media/icons/badanie-techniczne-green-3405d35a.svg";